module.exports = __webpack_public_path__ + "static/media/presse-parallax.9761b800.jpg";